import React, { useState } from "react";
import "./style.scss";
import { News } from "../../models/News";
import ReadMore from "../../../features/ReadMore";
import LightBox from "../../../features/LightBox";
interface IProps {
  item: News;
}

const SingleNews: React.FC<IProps> = ({ item }: IProps) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="news-block">
      <div onClick={() => setOpen(!open)} className="news-img shadow" style={{ backgroundImage: `url(${item.picture})` }}></div>
      <div className="news-section">
        <h2>{item.title}</h2>
        {item.body.length > 120 ? (
          <ReadMore text={item.body} minLengthText={120} title={item.title} />
        ) : (
          <article dangerouslySetInnerHTML={{ __html: item.body }}></article>
        )}
      </div>
      {open && (
        <LightBox
          imageUrl={item.picture}
          open={open}
          closeModal={() => setOpen(false)}
          onAccept={() => {}}
        >
        </LightBox>
      )}
    </div>
  );
};

export default SingleNews;
